import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import { Drawer, useMediaQuery, IconButton, Box, Toolbar, Badge } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import ESSNavigation from '../sections/ESSNavigation';
import { Notifications } from '@mui/icons-material';
import EssPunch from '../../app/ess/EssAttendance/components/EssPunch';
import EssNotificationBadge from '../../app/ess/EssNotification/components/EssNotificationBadge';

const drawerWidth = 300;

const EssLayout = ({ children }) => {
  const theme = useTheme();
  const { authUser } = useAuth();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  

  return (
    <Box sx={{ display: 'flex' }}>
		{/* 1. THE NAVBAR */}
		<nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top shadow mb-0" 
			style={{ position: 'fixed', width: '100%', zIndex: theme.zIndex.drawer + 1 }}>
			<div className="container-fluid">
				<Link className="me-5" to="/"><img src='/erp.png' alt="logo" style={{ height: 40 }} /></Link>
				<Box sx={{ flexGrow: 1 }} />
				{isMobile && (
					<IconButton color="inherit" onClick={handleDrawerToggle} sx={{ mr: 2 }}>
						<MenuIcon />
					</IconButton>
				)}
				{!isMobile && <span className='me-2'><EssPunch/></span> }
				<EssNotificationBadge />
			</div>
		</nav>

		{/* 2. THE DRAWER */}
		<Drawer
			variant={isMobile ? 'temporary' : 'permanent'}
			open={isMobile ? mobileOpen : true}
			onClose={handleDrawerToggle}
			sx={{
			width: drawerWidth,
			flexShrink: 0,
			[`& .MuiDrawer-paper`]: { 
				width: drawerWidth, 
				boxSizing: 'border-box',
				// This ensures the drawer doesn't overlap the top navbar
				marginTop: isMobile ? 0 : '75px' 
			},
			}}
		>
			<ESSNavigation />
		</Drawer>

		{/* 3. THE MAIN CONTENT AREA */}
		<Box
			component="main"
			sx={{
			flexGrow: 1,
			p: 1,
			width: { sm: `calc(100% - ${drawerWidth}px)` },
			mt: isMobile ? "50px" : '70px' 
			}}
		>
			{/* This is where your page content (Routes) will render */}
			{children}
		</Box>
		</Box>
  );
};

export default EssLayout;